import React from "react"

import Layout from "../components/layout";
import Image from "../components/image";
import Seo from "../components/seo";
import Social from "../components/social";
import ModeSwitcher from "../components/modeSwitcher";

const IndexPage = () => (
  <Layout>
    <Seo title="Home" />
    <div className="flex flex-wrap mb-4">
      <div className="w-full lg:w-2/5">
        <div
          className="mt-3 m-auto lg:m-0"
          style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}
        >
          <Image />
          <ModeSwitcher></ModeSwitcher>
        </div>
      </div>
      <div className="w-full lg:w-3/5 text-center lg:text-left">
        <h2 className="text-5xl font-bold tracking-tighter mb-5">
          Hey, welcome to my blog!
        </h2>
        <div className="text-lg">
          <p className="mb-5">
            I'm an Electronics Engineer based in Thessaloniki, Greece.
          </p>
          <p className="mb-5">
            Been tinkering in electronics since early stages of my life, so Ι followed this path.
            During my studies, a subject changed my mind about programming. That was the embedded systems class.
            Writing code to talk directly to the chip intrigued me. So that's how all began.
          </p>
          <p className="mb-5">
            Since then, on my free time I've been creating projects with embedded systems and learning new stuff,
            like IoT technologies, user interfaces, RTOS and more.
          </p>
          <p className="mb-5">
            I decided to create this blog, to share my experience not only with embedded systems,
            but in electronics as well. Welcome on board!
          </p>
        </div>
        <Social />
      </div>
    </div>
  </Layout>
)

export default IndexPage
